import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import TestnetSection from "../../components/TestnetSection/TestnetSection";
import AtomEVM from "../../components/MonadLabSection/MonadLabSection";
import AtomMarquee from "../../components/maqueeAtom/AtomMarquee";
import AtomArchitecture from "../../components/AtomArc/AtomArchitecture";
import AtomFeatures from "../../components/AtomFeatures";
import AtomTokenomics from "../../components/TokenomicSection/TokenomicSection";
import WhatsNewSection from "../../components/WhatsNewSection/WhatsNewSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";


const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = "Atom Foundation L3 Powered by Ethereum";
  }, []);

  return (
    <Fragment>
        <div className='AtomWeb'>
          <div className="body_wrap o-clip">
            <Header />
            <main>
              <HeroSection />
              
              <AtomEVM />
              <AtomMarquee />
              <TestnetSection />
              <AtomArchitecture />         
              <AtomFeatures />
              <AtomTokenomics />
              <WhatsNewSection />
              {/* About / "Who We Are" section ocultada temporalmente */}
              {/* <AboutSection/> */}
            </main>
             
            <Footer />
            <Scrollbar />
          </div>
        </div>
    </Fragment>
  );
};

export default HomePage;
